<div mat-dialog-title class="flex-container">
  <button
    mat-button
    class="close"
    (click)="onNoClick()"
    [mat-dialog-close]="true"
  >
    <mat-icon>close</mat-icon>
  </button>
  <h1 mat-dialog-title>Add Service Address</h1>
</div>

<form [formGroup]="serviceAddressForm" autocomplete="off">
  <div mat-dialog-content class="MinH100">
    <div>
      <mat-dialog-content class="update-popup1 addservice-address">
        <table class="Allpadd0 width100">
          <tr class="width100 pull-left">
            <mat-form-field
              appearance="fill"
              class="my-form-field width100 padd0"
            >
              <label>Address </label>
              <input
                matInput
                formControlName="address"
                class="form-control input1"
                placeholder="Enter Address"
              />
              <mat-error
                class="padd0"
                *ngIf="checkError('address', 'required')"
              >
                * Address is required</mat-error
              >
            </mat-form-field>
          </tr>
          <tr class="width100">
            <mat-form-field
              appearance="fill"
              class="my-form-field width100 padd0"
            >
              <label>City </label>
              <input
                matInput
                formControlName="city"
                class="form-control input1"
                pattern="[a-zA-Z\s]*"
                placeholder="Enter City Name"
              />
              <mat-error class="padd0" *ngIf="checkError('city', 'required')">
                * City is required</mat-error
              >
              <mat-error *ngIf="checkError('city', 'pattern')">
                * Invalid City</mat-error
              >
            </mat-form-field>
          </tr>
          <tr class="width100">
            <mat-form-field
              appearance="fill"
              class="my-form-field width100 padd0"
            >
              <label>State </label>
              <mat-select
                formControlName="state"
                class="form-control"
                placeholder="Select State"
              >
                <mat-option
                  *ngFor="let item of statesList"
                  [value]="item.stateId"
                >
                  {{ item.state }}
                </mat-option>
              </mat-select>
              <mat-error class="padd0" *ngIf="checkError('state', 'required')">
                * State is required</mat-error
              >
            </mat-form-field>
          </tr>
          <tr class="width100">
            <mat-form-field
              appearance="fill"
              class="my-form-field width100 padd0"
            >
              <label>Zip Code: </label>
              <input
                matInput
                formControlName="zip"
                class="input1"
                placeholder="Enter ZipCode"
                maxlength="5"
                onKeyPress="if(this.value.length==5) return false;"
              />
              <mat-error class="padd0" *ngIf="checkError('zip', 'required')">
                * Zip is required</mat-error
              >
              <mat-error *ngIf="checkError('zip', 'pattern')">
                * Invalid Zip Code</mat-error
              >
            </mat-form-field>
          </tr>
        </table>
      </mat-dialog-content>
    </div>
  </div>
  <div mat-dialog-actions class="pp-add-service-btn">
    <button n-submit class="btn btn-primary" (click)="onSubmit()" type="submit">
      Add Address
    </button>
  </div>
</form>
